import { COMPANY_BRANDS } from "../../lib/brands";
import { DirectoryPicker } from "../DirectoryPicker";

export function BasicSection({ form, set, setForm, customers, editingId, reloadCustomers }) {
  return (
    <>
      <div>
        <div className="section-title">Receipt</div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="input-label">LR Number {editingId ? "" : "(type digits only)"}</label>
            <div className="flex">
              <span className="inline-flex items-center px-3 border border-r-0 border-[#D8D6CE] bg-[#F0EEE8] text-sm text-[#68665E] font-medium whitespace-nowrap">LR No.</span>
              <input className="input-field font-mono rounded-l-none" inputMode="numeric"
                value={(form.lr_number || "").replace(/^LR No\.\s*/i, "")}
                onChange={(e)=>{ const dg = e.target.value.replace(/[^0-9]/g, ""); set("lr_number", dg ? `LR No. ${dg}` : ""); }}
                placeholder={editingId ? "" : "e.g. 123"} data-testid="lr-number-input" />
            </div>
          </div>
          <div><label className="input-label">LR Date</label><input type="date" className="input-field" value={form.lr_date} onChange={(e)=>set("lr_date", e.target.value)} data-testid="lr-date-input" /></div>
          <div><label className="input-label">Client Ref / Doc No.</label><input className="input-field" value={form.client_ref_no || ""} onChange={(e)=>set("client_ref_no", e.target.value)} placeholder="Client's order / doc no." data-testid="lr-client-ref-no" /></div>
          <div><label className="input-label">Client Ref Date</label><input type="date" className="input-field" value={form.client_ref_date || ""} onChange={(e)=>set("client_ref_date", e.target.value)} data-testid="lr-client-ref-date" /></div>
          <div><label className="input-label">Payment Mode</label>
            <select className="input-field" value={form.payment_mode} onChange={(e)=>set("payment_mode", e.target.value)} data-testid="lr-payment-mode">
              <option>To Pay</option><option>Paid</option><option>TBB</option>
            </select>
          </div>
          <div><label className="input-label">Status</label>
            <select className="input-field" value={form.status} onChange={(e)=>set("status", e.target.value)} data-testid="lr-status">
              <option value="loading">Loading</option>
              <option value="in_transit">In Transit</option>
              <option value="delivered">Delivered</option>
              <option value="inv_generated">Inv Generated</option>
              <option value="inv_submitted">Inv Submitted</option>
              <option value="paid">Paid</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
          <div><label className="input-label">Issue Under (Company on PDF)</label>
            <select className="input-field" value={form.company_brand || "ito_engineering"} onChange={(e)=>set("company_brand", e.target.value)} data-testid="lr-company-brand">
              {COMPANY_BRANDS.map((b)=><option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div>
        <div className="section-title">Hirer / Client <span className="text-[11px] font-normal text-[#68665E]">(who hired us — pick from the directory; use ＋ Add to directory for anyone new)</span></div>
        <DirectoryPicker
          customers={customers}
          reloadCustomers={reloadCustomers}
          kind="all"
          testPrefix="lr-hirer"
          value={{ company: form.hirer?.name, gst: form.hirer?.gst, address: form.hirer?.address,
                   poc_name: form.hirer?.contact_name, poc_phone: form.hirer?.contact_phone, poc_email: form.hirer?.contact_email }}
          onSelect={(p) => setForm((f) => ({
            ...f,
            ...(p.company_id !== undefined ? { company_id: p.company_id } : {}),
            ...(p.department_id !== undefined ? { department_id: p.department_id } : {}),
            ...(p.contact_id !== undefined ? { contact_id: p.contact_id } : {}),
            hirer: {
              ...f.hirer,
              ...(p.company !== undefined ? { name: p.company } : {}),
              ...(p.gst !== undefined ? { gst: p.gst } : {}),
              ...(p.address !== undefined ? { address: p.address } : {}),
              ...(p.division !== undefined ? { division: p.division } : {}),
              ...(p.poc_name !== undefined ? { contact_name: p.poc_name } : {}),
              ...(p.poc_phone !== undefined ? { contact_phone: p.poc_phone } : {}),
              ...(p.poc_email !== undefined ? { contact_email: p.poc_email } : {}),
            },
          }))}
        />
      </div>
    </>
  );
}
